export default angular.module('tooltip', [])
    .directive('tooltip', function ($document, $sce, $compile) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element, attrs) {
            var tip = $compile('<div ng-class="tipClass"><span ng-bind-html="text"></span><div class="tooltip-arrow"></div></div>')(scope), tipClassName = 'tooltip ee-angularjs-tooltip', tipActiveClassName = 'tooltip-show';
            scope.tipClass = [tipClassName];
            scope.text = $sce.trustAsHtml(attrs.tooltip);
            if (attrs.tooltipPosition) {
                scope.tipClass.push('tooltip-' + attrs.tooltipPosition);
            }
            else {
                scope.tipClass.push('tooltip-up');
            }
            element.append(tip);
            element.bind('mouseover', function (e) {
                tip.addClass(tipActiveClassName);
                var pos = e.target.getBoundingClientRect(), offset = scope.offset(tip), tipHeight = angular.element(e.target).prop('offsetHeight'), //tip.offsetHeight,
                tipWidth = angular.element(e.target).prop('offsetWidth'), //tip.offsetWidth,
                elWidth = pos.width || pos.right - pos.left, elHeight = pos.height || pos.bottom - pos.top, tipOffset = 20;
                offset.top = tipHeight + tipOffset;
                offset.left = (tipWidth / 2);
                scope.offset(tip, offset);
            });
            element.bind('mouseout', function () {
                tip.removeClass(tipActiveClassName);
            });
            element.bind('click', function () {
                tip.toggleClass(tipActiveClassName);
            });
            tip.bind('mouseover', function () {
                tip.addClass(tipActiveClassName);
            });
            tip.bind('mouseout', function () {
                tip.removeClass(tipActiveClassName);
            });
            tip.bind('click', function () {
                tip.removeClass(tipActiveClassName);
            });
            scope.offset = function (elm, newOffset) {
                try {
                    return elm.offset();
                }
                catch (e) { }
                var rawDom = elm[0];
                var _x = 0;
                var _y = 0;
                var body = document.documentElement || document.body;
                var scrollX = window.pageXOffset || body.scrollLeft;
                var scrollY = window.pageYOffset || body.scrollTop;
                _x = rawDom.getBoundingClientRect().left + scrollX;
                _y = rawDom.getBoundingClientRect().top + scrollY;
                return {
                    left: _x,
                    top: _y
                };
            };
        }
    };
})
    .name;
//# sourceMappingURL=index.js.map